module.exports = "<h1>hello partner</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/partners/partners.component.html
// module id = 729
// module chunks = 8